<template>
<div class="vliveList bgc padding-20">
    <div class="filters">
        <div class="add">
            <el-button type="primary" v-if="permission.btnList.indexOf('A020301')==-1" @click="handleAdd">发布直播</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                <el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-input v-model.trim="param.subject" placeholder="请输入直播名称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="spackageName" label="直播名称" width="454px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img :src="scope.row.logourl" alt="" v-if="scope.row.logourl">
                        <img :src="defaultCover" alt="" v-else>
                        <div class="imageText-summary">
                            <div class="textBox">
                                <div class="text">
                                    <span class="recommon" v-if="scope.row.isinnerrecomm === 1">推荐</span>{{ scope.row.subject }}
                                </div>
                            </div>
                            <!-- <div class="price">
                                <span v-if="scope.row.feetype === 1">免费</span>
                                <span v-else>￥{{scope.row.saleprice}}</span>
                            </div> -->
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="livetypetext" label="直播类型" class-name="center"></el-table-column>
            <!--<el-table-column prop="viewcount" label="直播量" class-name="center"></el-table-column>-->
            <!--<el-table-column prop="ordercount" label="订单量" class-name="center"></el-table-column>-->
            <!--<el-table-column prop="begintime" label="开始时间" class-name="center"></el-table-column>-->
            <el-table-column prop="datetime" label="发布时间" class-name="center" width="200"></el-table-column>
            <el-table-column prop="ispublic" label="状态" class-name="center">
                <template slot-scope="scope">
                    <!-- <span :class="status(scope.row.status)">.{{scope.row.statustext | status}}</span> -->
                    <span :class="statusClass(scope.row.status)">· {{scope.row.statustext | status}}</span>
                    <!-- <el-tooltip content="发布的商品设置隐藏后，在店铺内不显示，但可以通过链接的方式访问" placement="top" v-if="scope.row.status != 100&&!scope.row.ispublic">
                        <div>
                            <i class="icon icon_warning"></i>
                        </div>
                    </el-tooltip> -->
                </template>
            </el-table-column>
            <el-table-column label="操作" width="240" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span v-if="permission.btnList.indexOf('A020302')==-1">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span v-if="permission.btnList.indexOf('A020302')==-1 && scope.row.livetype === 2">
                            <el-button @click="handleLive(scope.row)" type="text" size="small">直播</el-button>
                            <span class="separator">|</span>
                        </span>
                        <!-- <span v-if="[10,31].indexOf(scope.row.status)>-1 && permission.btnList.indexOf('A020303')==-1">
                            <el-button @click="handleOnShelf(scope.row)" type="text" size="small">上架</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span v-if="[30].indexOf(scope.row.status)>-1 && permission.btnList.indexOf('A020304')==-1">
                            <el-button @click="handleOffShelf(scope.row)" type="text" size="small">下架</el-button>
                            <span class="separator">|</span>
                        </span> -->
                        <span>
                            <Share :row='scope.row'></Share>
                        </span>
                        <span v-if="permission.btnList.indexOf('A020309')==-1">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span v-if="permission.btnList.indexOf('A020302')==-1 && scope.row.livetype === 2">
                            <el-button @click="handleSet(scope.row)" type="text" size="small">设置</el-button>
                        </span>
                        <el-dropdown v-if="scope.row.livetype === 1">
                            <span class="el-dropdown-link">
                                <el-button type="text" size="small">更多</el-button>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="handleToInfo(scope.row)" v-if="permission.btnList.indexOf('A020311')==-1">直播信息</el-dropdown-item>
                                <el-dropdown-item @click.native="handlePlaybackInterface(scope.row)" v-if="permission.btnList.indexOf('A020312')==-1">直播设置</el-dropdown-item>
                                <el-dropdown-item @click.native="handleToComment(scope.row)" v-if="permission.btnList.indexOf('A020306')==-1">评论信息</el-dropdown-item>
                                <el-dropdown-item @click.native="handlePlayback(scope.row)" v-if="scope.row.isrecord === 1 && scope.row.livetype === 1 && scope.row.status === '30'">回放设置</el-dropdown-item>
                                <!--<el-dropdown-item @click.native="handleToDataStatistics(scope.row)">统计信息</el-dropdown-item>-->
                                <!--<el-dropdown-item @click.native="handleRoster(scope.row)" v-if="permission.btnList.indexOf('A020310')==-1">名单管理</el-dropdown-item>-->
                                <!-- <el-dropdown-item @click.native="handleExtension(scope.row)" v-if="scope.row.feetype==2">直播推广</el-dropdown-item> -->
                                <!-- <el-dropdown-item @click.native="handleAddRec(scope.row)" v-if="!scope.row.isinnerrecomm">加入推荐</el-dropdown-item>
                                <el-dropdown-item @click.native="handleRemoveRec(scope.row)" v-if="scope.row.isinnerrecomm">取消推荐</el-dropdown-item> -->
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
    <setPlayBack ref="setPlayBack" />
</div>
</template>

<script>
import {getVliveList, getLiveList, editVliveStatus, deleteLivebyInnerid, editVlivePublic, editVliveIsplatform} from 'api/api'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {vliveMgtCode} from 'api/enumCode'
import {vliveMsg} from 'api/message'
import Share from '@/base/share/share2'
import {promiseUrlToQRCode} from 'common/js/tools'
import setPlayBack from './components/setPlayback'
export default {
    name: 'vliveList',
    data() {
        return {
            defaultCover: require('@/common/images/other/default_cover.png'),
            statusList: vliveMgtCode.status,
            total: 0,
            tableData: []
        }
    },
    props: ['param'],
    mounted() {
        this._getList()
    },
    methods: {
        handlePlayback(item) {
            this.$refs.setPlayBack.open(item.innerid)
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                }).catch(() => {
                    // 取消
                })
            } else {
                this.$router.push({name: 'VliveEdit'})
            }
        },
        handleSet(row) {
            this.$router.push({name: 'VliveLiveSet', query: {id: row.innerid}})
        },
        handleLive(row) {
            // this.$router.push({name: 'VliveLiveing', query: {innerid: row.innerid}})
            let routerUrl = this.$router.resolve({name: 'VliveLiveing', query: {innerid: row.innerid}})
            window.open(routerUrl.href,'_blank')
        },
        handleEdit(row) {
            this.$router.push({name: 'VliveEdit', query: {id: row.innerid, type: row.livetype}})
        },
        handlePlaybackInterface(row) {
            this.$router.push({name: 'VlinePlaybackInterface', query: {id: row.innerid}})
        },
        handleExtension(row) {
            this.$router.push({name: 'CouponList', query: {id: row.innerid, kmctype: 3}})
        },
        handleRoster(row) {
            this.$router.push({name: 'VliveRoster', query: {id: row.innerid}})
        },
        handleToDataStatistics(row) {
            this.$router.push({name: 'VliveDataStatistics', query: {id: row.innerid}})
        },
        handleToInfo (row) {
            this.$router.push({name: 'VliveInfo', query: {id: row.innerid}})
        },
        handleToComment (row) {
            this.$router.push({name: 'VliveComment', query: {id: row.innerid}})
        },
        handleAddRec(row) {
            let isinnerrecomm = 1
            this.$confirm(vliveMsg.addRec.msg, vliveMsg.addRec.title, {
                confirmButtonText: vliveMsg.addRec.confirmText,
                cancelButtonText: vliveMsg.addRec.cancelText
            }).then(() => {
                this._editisinnerrecomm(row.innerid, isinnerrecomm, vliveMsg.addRec.successMsg)
            }).catch(() => {})
        },
        handleRemoveRec(row) {
            let isinnerrecomm = 0
            this.$confirm(vliveMsg.removeRec.msg, vliveMsg.removeRec.title, {
                confirmButtonText: vliveMsg.removeRec.confirmText,
                cancelButtonText: vliveMsg.removeRec.cancelText
            }).then(() => {
                this._editisinnerrecomm(row.innerid, isinnerrecomm, vliveMsg.removeRec.successMsg)
            }).catch(() => {})
        },
        handleDel(row) {
            let status = 100
            this.$confirm('确定要删除直播吗？删除后所有链接里的视频都会失效！', '删除直播', {
                confirmButtonText: vliveMsg.del.confirmText,
                cancelButtonText: vliveMsg.del.cancelText
            }).then(() => {
                console.log(row)
                if (row.livetype === 1) {
                    this._editStatus(row.innerid, status, vliveMsg.del.successMsg)
                } else {
                    this._editStatus2(row.innerid, status, vliveMsg.del.successMsg)
                }
            }).catch(() => {})
        },
        handleOffShelf(row) {
            let status = 31
            this.$confirm(vliveMsg.offShelf.msg, vliveMsg.offShelf.title, {
                confirmButtonText: vliveMsg.offShelf.confirmText,
                cancelButtonText: vliveMsg.offShelf.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, vliveMsg.offShelf.successMsg)
            }).catch(() => {})
        },
        handleOnShelf(row) {
            let status = 30
            this._editStatus(row.innerid, status, vliveMsg.onShelf.successMsg)
        },
        _editisinnerrecomm(innerid, status, tip) {
            this.setLoading(true)
            editVliveIsplatform({
                data: {
                    innerid: innerid,
                    isinnerrecomm: status
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 删除图文直播
        _editStatus2(innerid, status, tip) {
            this.setLoading(true)
            deleteLivebyInnerid({
                data: {
                    innerid: innerid
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editStatus(innerid, status, tip) {
            this.setLoading(true)
            editVliveStatus({
                data: {
                    innerid: innerid,
                    status: status
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editIspublic(innerid, ispublic, tip) {
            this.setLoading(true)
            editVlivePublic({
                data: {
                    innerid: innerid,
                    ispublic: ispublic
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            let tmp = {subject: this.param.subject}
            if (this.param.ispublic === 100) {
                tmp.status = 100
            } else if (this.param.ispublic === 0 || this.param.ispublic === 1) {
                tmp.ispublic = this.param.ispublic
            }
            this.setLoading(true)
            // getVliveList({
            getLiveList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.tableData.forEach(obj => {
                        promiseUrlToQRCode(obj.shareurl, obj.logourl).then(
                            function(data) {
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        statusClass(val) {
            if (val === '0') {
                return 'tc-orange'
            } else if (val === '10') {
                return 'tc-green'
            } else {
                return 'tc-grey'
            }
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            for (let i = 0; i < vliveMgtCode.status.length; i++) {
                if (value === vliveMgtCode.status[i].code) {
                    return vliveMgtCode.status[i].name
                }
            }
            return value
        },
        ispublic: function (value) {
            for (let i = 0; i < vliveMgtCode.ispublic.length; i++) {
                if (value === vliveMgtCode.ispublic[i].code) {
                    return vliveMgtCode.ispublic[i].name
                }
            }
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < vliveMgtCode.status.length; i++) {
                    if (value === vliveMgtCode.status[i].code) {
                        return vliveMgtCode.status[i].cls
                    }
                }
                return value
            }
        },
        ispublic () {
            return function(value) {
                for (let i = 0; i < vliveMgtCode.ispublic.length; i++) {
                    if (value === vliveMgtCode.ispublic[i].code) {
                        return vliveMgtCode.ispublic[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'permission',
            'shop'
        ])
    },
    components: {
        Page,
        Share,
        setPlayBack
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveList {
    .result-list{
        .el-table__row{
            height: 100px;
        }
        .imageText{
            .imageText-summary{
                .textBox{
                    width: 345px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 340px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;

                        margin-left: -30px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 96%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon{
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price{
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        img{
            min-width: 100px;
            max-width: 100px;
            height: 60px;
        }
        .icon{
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
        .el-table__row:hover{
            .textBox{
                &::after{
                    background: #F5F7FA;
                }
            }
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1){
        margin-bottom: 0;
    }
    .el-table{
        .title{
            .cell{
                padding: 0;
                margin-left: 5px;
            }
        }
        .center{
            .cell{
                text-align: center;
            }
        }
    }
}
</style>
